import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { forgotPassword } from '../../../actions/AuthenticationActionCreators';
import FontAwesome from 'react-fontawesome';
import { FormattedMessage, intlShape } from 'react-intl';
import accountMessages from './AccountMessages';
import commonMessages from '../../../intl/CommonMessages';
import Form from 'react-form-controlled';

class GenerateResetForm extends Component {

  static propTypes = {
    passwordResetLoading: PropTypes.bool.isRequired,
    defaultEmailAddress: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);

    this.state = {
      emailAddress: props.defaultEmailAddress
    };
  }

  processForgot = state => {
    console.log('User forgot clicked');
    this.context.executeAction(forgotPassword, state);
  };

  formChanged = state => {
    this.setState(state);
  };


  render() {

    const { passwordResetLoading } = this.props;

    const message = passwordResetLoading ?
      <FontAwesome name='cog' spin/> :
      <FormattedMessage { ...commonMessages.reset } />;

    return <Form className='login'
                 value={this.state}
                 onChange={this.formChanged}
                 onSubmit={ this.processForgot }>
      <fieldset className='form-group'>
        <label className='sr-only' htmlFor='emailAddress'>
          <FormattedMessage { ...accountMessages.emailAddress } />
        </label>
        <div className='input-group'>
          <input type='email' className='form-control form-control-success form-control-error' name='emailAddress'
                 placeholder='Email Address'
                 disabled={ passwordResetLoading }/>
          <div className='input-group-append'>
            <span className='input-group-text'><FontAwesome name='envelope'/></span>
          </div>
        </div>
      </fieldset>
      <button className='btn btn-primary'
              type='submit'
              disabled={ passwordResetLoading }>
        { message }
      </button>
    </Form>;
  }
}

export default GenerateResetForm;



// WEBPACK FOOTER //
// ./src/apps/Account/components/GenerateResetForm.js